import React, { Component } from 'react';
import { SearchSchoolResultItem } from './SearchSchoolResultItem';
import PropTypes from 'prop-types';
import { ShowCompleteListButton } from '../SearchExt/SearchResultsBlock';
import format from 'date-fns/format';
import nl from 'date-fns/locale/nl';

export class SearchSchoolResultGroup extends Component {

  constructor(props) {
    super(props);

    this.state = { viewAll: false };
  }

  /**
     * Toggle the hidden trainings
     * @private
     */
  _toggleRows() {
    this.setState({ viewAll: !this.state.viewAll });
  }

  render() {
    const { trainings, post } = this.props;
    const { viewAll } = this.state;
    const intitialLimit = 3;

    // set limit of visible training items
    const limit = viewAll ? 999999 : intitialLimit;


    const trainingItems = trainings
      .filter((training, key) => key < limit) // filter list depending on limit
      .map(training => {
        return (<SearchSchoolResultItem
          key={training.id_training}
          training={training}
          post={post}/>);
      });

    const date = format(
      new Date(trainings[0].datum_start),
      'd MMMM',
      { locale: nl }
    );
    const title = `Startdatum ${date}`;

    return (
      <div className="school-page__result-group">
        <h3 className="school-page__result-group-title">
          {title}
        </h3>
        {trainingItems}
        {trainings.length > intitialLimit
                && <ShowCompleteListButton
                  viewAll={viewAll}
                  total={trainings.length}
                  onClicked={() => this._toggleRows()}/>}
      </div>
    );
  }
}

SearchSchoolResultGroup.propTypes = {
  trainings: PropTypes.arrayOf(
    PropTypes.object
  ),
  post: PropTypes.object,
};

